import {
  SET_KENSHI_LOADING,
  SET_KENSHI_ERROR,
  SET_KENSHI,
} from "../actionTypes/index";
// import { baseUrl } from "../../apis/baseUrl";
import { errorAlert } from "../../helpers/alerts";

const setKenshi = (payload) => {
  return { type: SET_KENSHI, payload };
};

const setKenshiError = (payload) => {
  return { type: SET_KENSHI_ERROR, payload };
};

const setKenshiLoading = (payload) => {
  return { type: SET_KENSHI_LOADING, payload };
};

export const getAllKenshi = () => {
  return async (dispatch, getState) => {
    dispatch(setKenshiLoading(true));
    dispatch(setKenshiError(null));
    try {
      // const { data } = await baseUrl.get("/kenshi/all", {
      //   headers: { access_token: localStorage.access_token },
      // });
      const data = [
        {
          "id" : 1,
          "nik": "12312",
          "email" : "yohvan@mail.com",
          "level" : "Nidan",
          "role" : "admin",
          "name" : "Yohanes Vandi Kurniawan",
          "status": "active",
          "Dojo" : {"id" : 1, "name" : "Dojo Kota Malang"},
        },
        {
          "id" : 2,
          "nik": "3213213",
          "email" : "jovan@mail.com",
          "level" : "Nikyu",
          "role" : "user",
          "name" : "Michael Jovan Gunawan",
          "status": "active",
          "Dojo" : {"id" : 2, "name" : "Dojo Kota Surabaya"}
        }
      ]
      dispatch(setKenshi(data));
    } catch (err) {
      dispatch(setKenshiError(err));
      errorAlert(err.response.data.message);
      throw new Error(err.response.data.message);
    } finally {
      dispatch(setKenshiLoading(false));
    }
  };
};

export const registerKenshi = (newKenshiFormData) => {
  return async (dispatch, getState) => {
    dispatch(setKenshiLoading(true));
    dispatch(setKenshiError(null));
    try {
      // await baseUrl.post(
      //   "/kenshi/register",
      //   newKenshiFormData,
      //   { headers: { access_token: localStorage.access_token } }
      // );
      // dispatch(getAllKenshi())
    } catch (err) {
      dispatch(setKenshiError(err));
      errorAlert(err.response.data.message);
      throw new Error(err.response.data.message);
    } finally {
      dispatch(setKenshiLoading(false));
    }
  };
};

export const editKenshi = (id, editKenshiFormData) => {
  return async (dispatch, getState) => {
    dispatch(setKenshiLoading(true));
    dispatch(setKenshiError(null));
    try {
      // await baseUrl.put(
      //   `/kenshi/edit/${id}`,
      //   editKenshiFormData,
      //   { headers: { access_token: localStorage.access_token } }
      // );
      // dispatch(getAllKenshi())
    } catch (err) {
      dispatch(setKenshiError(err));
      errorAlert(err.response.data.message);
      throw new Error(err.response.data.message);
    } finally {
      dispatch(setKenshiLoading(false));
    }
  };
};
